import { useEffect } from 'react'
import { ConditionConfig, useConditionsContext } from './ConditionsContext'

export function useConditions(config?: ConditionConfig): {
  conditions: ConditionConfig[]
  edit: (id: string) => void
  hide: (id: string) => void
  show: (id: string) => void
}

export function useConditions(config?: ConditionConfig) {
  const { conditions, register, hide, show } = useConditionsContext()

  useEffect(() => {
    if (config) {
      register(config)
    }
  }, [config, register])

  return {
    conditions: Object.values(conditions),
    edit: (id: string) => conditions[id]?.onEdit(),
    hide,
    show,
  }
}
